<template lang="pug">
  div
    divider(label="Dados do cartório")
    el-row(type='flex')
      el-col(:span="12").container-input
        validation-provider(rules="required", v-slot="{ errors }")
          app-label(label="Nome do cartório:", :required="true")
          el-select.input.w-98(
            class="select",
            v-model="oficio.cartorio.nome",
            placeholder="Selecione",
            filterable,
            no-match-text="Nenhum cartório encontrado",
            value-key="id",
            :class="{'erro' : errors.length}"
            @change="cartorioSelecionado"
          )
            el-option(
              v-for="item in cartorios",
              :key="item.id",
              :label="item.nome",
              :value="item"
            )
          span.help.erro {{ errors[0] }}
      el-col(:span="12").container-input
        app-label(label="Estado:", :required="true")
        el-input.input(
          value="Pará"
          :disabled="true"
        )
    divider(label="Dados do processo")
    el-row(type='flex')
      el-col(:span="8").container-input
        app-label(label="Número:", :required="true")
        el-input.input.w-98(
          :disabled="true"
          v-model="oficio.processo.numeroProcesso"
        )
      el-col(:span="8").container-input
        app-label(label="Município:", :required="true")
        el-input.input.w-98(
          :disabled="true"
          v-model="oficio.processo.cadastroColetivo.pecaTecnica.municipios[0].nome"
        )
      el-col(:span="8").container-input
        app-label(label="Gleba:", :required="true")
        el-input.input(
          :disabled="true"
          v-model="oficio.processo.cadastroColetivo.pecaTecnica.gleba"
        )
    el-row(type='flex')
      el-col(:span="8").container-input
        app-label(label="Área total:", :required="true")
        el-input.input.w-98(
          :disabled="true"
          :value="area"
        )
      el-col(:span="8").container-input
      el-col(:span="8").container-input
</template>

<script>
import Divider from '@/screens/arrecadacao/components/Divider'
import AppLabel from '@/components/AppLabel'
import DadosOficio from '@/screens/arrecadacao/cpat/components/oficio/DadosOficio'
import DadosCartorio from '@/screens/arrecadacao/cpat/components/oficio/DadosCartorio'
import DadosProcesso from '@/screens/arrecadacao/cpat/components/oficio/DadosProcesso'
import { mapActions } from 'vuex'
import Utils from '@/utils/utils'

export default {
  components: {
    Divider,
    AppLabel,
    DadosOficio,
    DadosCartorio,
    DadosProcesso
  },
  data () {
    return {
      cartorios: []
    }
  },
  computed: {
    cepFormatado () {
      if (this.oficio.cartorio.endereco) {
        return this.formatCEP(this.oficio.cartorio.endereco.cep)
      } else {
        return ''
      }
    },
    complementoFormatado () {
      if (this.oficio.cartorio.nome) {
        return this.oficio.cartorio.endereco.complemento || '-'
      } else {
        return ''
      }
    },
    area () {
      const json = JSON.parse(this.oficio.processo.cadastroColetivo?.pecaTecnica?.dadoPecaTecnica?.jsonPlanilha)
      if (json) {
        return this.format(json?.identificacaoPlanilha?.areaTotal, { prefix: '', suffix: '', thousands: '.', decimal: ',', precision: 4 })
      }
      return this.format(this.cadastro?.pecaTecnica?.area, { prefix: '', suffix: '', thousands: '.', decimal: ',', precision: 4 })
    }
  },
  methods: {
    ...mapActions({
      findCartoriosByProcesso: 'cartorioArrecadacao/findCartoriosByProcesso',
      findCartorioById: 'cartorioArrecadacao/findCartorioById'
    }),
    formatCEP: Utils.formatCEP,
    format: Utils.format,
    async getCartoriosPA () {
      this.cartorios = await this.findCartoriosByProcesso(this.oficio.processo.id)
    },
    async cartorioSelecionado (value) {
      if (value && value.id) {
        const id = value.id.toString()
        const cartorio = await this.findCartorioById({ id: id })
        this.oficio.cartorio = cartorio
      }
    }
  },
  created () {
    if (this.oficio.processo.id) {
      this.getCartoriosPA()
    }
  },
  props: {
    oficio: {
      type: Object,
      required: true
    }
  },

  watch: {
    oficio: {
      async handler (val) {
        if (this.oficio.processo) {
          this.getCartoriosPA()
        }
      },

      deep: true
    }
  }
}
</script>

<style scoped>
.container-input {
  margin-right: 10px;
  margin-left: 10px;
}

.w-98 {
  width: 98%;
}

.el-select {
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/screens/arrecadacao/cpat/components/matricula/InformarDados.vue